import { useState, useEffect } from 'react'
import {
  Title, Card, TextInput, Button, Group, Stack, Text,
  Divider, Loader, ActionIcon,
} from '@mantine/core'
import { IconPlus, IconTrash, IconGripVertical } from '@tabler/icons-react'
import { notifications } from '@mantine/notifications'
import { api } from '@/lib/api'

export default function CategorySettings() {
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [courseCategories, setCourseCategories] = useState<string[]>([])
  const [videoCategories, setVideoCategories] = useState<string[]>([])

  useEffect(() => {
    api.admin.getCategories()
      .then((res: any) => {
        setCourseCategories(res.courseCategories || [])
        setVideoCategories(res.videoCategories || [])
      })
      .catch(() => {
        notifications.show({ title: 'Алдаа', message: 'Ангилал ачаалахад алдаа гарлаа', color: 'red' })
      })
      .finally(() => setLoading(false))
  }, [])

  const handleSave = async () => {
    const filtered = {
      courseCategories: courseCategories.filter((c) => c.trim()),
      videoCategories: videoCategories.filter((c) => c.trim()),
    }
    setSaving(true)
    try {
      await api.admin.updateCategories(filtered)
      setCourseCategories(filtered.courseCategories)
      setVideoCategories(filtered.videoCategories)
      notifications.show({ title: 'Амжилттай', message: 'Ангилал хадгалагдлаа', color: 'green' })
    } catch {
      notifications.show({ title: 'Алдаа', message: 'Хадгалахад алдаа гарлаа', color: 'red' })
    } finally {
      setSaving(false)
    }
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}>
        <Loader />
      </div>
    )
  }

  return (
    <div>
      <Group justify="space-between" mb="lg">
        <Title order={2}>Ангилал тохиргоо</Title>
        <Button onClick={handleSave} loading={saving}>Хадгалах</Button>
      </Group>

      {/* Course Categories */}
      <Title order={4} mb="sm">Сургалтын ангилал</Title>
      <Card shadow="xs" padding="md" radius="md" withBorder mb="xl">
        <Stack gap="xs">
          {courseCategories.map((cat, i) => (
            <Group key={i} gap="xs">
              <IconGripVertical size={16} color="gray" />
              <TextInput
                value={cat}
                onChange={(e) => {
                  const value = e?.target?.value ?? ''
                  setCourseCategories((prev) =>
                    prev.map((c, idx) => (idx === i ? value : c))
                  )
                }}
                style={{ flex: 1 }}
              />
              <ActionIcon
                variant="light"
                color="red"
                radius="md"
                onClick={() => setCourseCategories((prev) => prev.filter((_, idx) => idx !== i))}
              >
                <IconTrash size={16} />
              </ActionIcon>
            </Group>
          ))}
          {courseCategories.length === 0 && (
            <Text c="dimmed" size="sm" ta="center" py="sm">Ангилал байхгүй байна</Text>
          )}
        </Stack>
        <Button
          variant="light"
          leftSection={<IconPlus size={16} />}
          mt="sm"
          size="xs"
          onClick={() => setCourseCategories((prev) => [...prev, ''])}
        >
          Ангилал нэмэх
        </Button>
      </Card>

      <Divider mb="xl" />

      {/* Video Categories */}
      <Title order={4} mb="sm">Видео ангилал</Title>
      <Card shadow="xs" padding="md" radius="md" withBorder mb="xl">
        <Stack gap="xs">
          {videoCategories.map((cat, i) => (
            <Group key={i} gap="xs">
              <IconGripVertical size={16} color="gray" />
              <TextInput
                value={cat}
                onChange={(e) => {
                  const value = e?.target?.value ?? ''
                  setVideoCategories((prev) =>
                    prev.map((c, idx) => (idx === i ? value : c)))
                }}
                style={{ flex: 1 }}
              />
              <ActionIcon
                variant="light"
                color="red"
                radius="md"
                onClick={() => setVideoCategories((prev) => prev.filter((_, idx) => idx !== i))}
              >
                <IconTrash size={16} />
              </ActionIcon>
            </Group>
          ))}
          {videoCategories.length === 0 && (
            <Text c="dimmed" size="sm" ta="center" py="sm">Ангилал байхгүй байна</Text>
          )}
        </Stack>
        <Button
          variant="light"
          leftSection={<IconPlus size={16} />}
          mt="sm"
          size="xs"
          onClick={() => setVideoCategories((prev) => [...prev, ''])}
        >
          Ангилал нэмэх
        </Button>
      </Card>

      <Group justify="flex-end">
        <Button onClick={handleSave} loading={saving} size="md">Бүгдийг хадгалах</Button>
      </Group>
    </div>
  )
}
